import { useState } from 'react';

import * as styles from './Guide.css';

interface CommunityImageProps {
  logoUrl?: string | null;
  communityName: string;
  loading?: 'lazy' | 'eager';
  fetchPriority?: 'high' | 'low' | 'auto';
}

/**
 * CommunityImage component
 * Handles community logo display with proper loading states and fallback
 * Prevents flickering by managing image load state
 */
export function CommunityImage({ logoUrl, communityName, loading = 'lazy', fetchPriority = 'auto' }: CommunityImageProps) {
  const [imageError, setImageError] = useState(false);
  const firstLetter = communityName.charAt(0).toUpperCase();

  const handleImageError = () => {
    setImageError(true);
  };

  // Show placeholder only if: no logo URL OR image failed to load
  const showPlaceholder = !logoUrl || imageError;

  return (
    <>
      {logoUrl && !imageError && (
        <img
          alt=""
          aria-hidden="true"
          className={styles.communityLogo}
          crossOrigin="anonymous"
          decoding="async"
          fetchPriority={fetchPriority}
          loading={loading}
          src={logoUrl}
          onError={handleImageError}
        />
      )}
      {showPlaceholder && (
        <div aria-hidden="true" className={styles.communityLogoPlaceholder}>
          {firstLetter}
        </div>
      )}
    </>
  );
}
